// RAD
export const collectionDiagnosi = "2.16.840.1.113883.6.103"
export const collectionAgente = "2.16.840.1.113883.2.9.77.22.11.2"
export const collectionReazione = "2.16.840.1.113883.6.103"

// RSA
export const collectionDiagnosiRsa = "2.16.840.1.113883.6.103"
export const collectionTerapiaAttuale = "2.16.840.1.113883.2.9.6.1.5" // non c'è su GITHUB!
export const collectionAccertamentiConsigliati = "2.16.840.1.113883.6.1";

export const collectionTerapieFarmacologiche_ATC = {
    name: 'ATC',
    code: '2.16.840.1.113883.6.73', // non c'è su GITHUB!
    displayName: 'Farmaci ATC'
};
export const collectionTerapieFarmacologiche_AIC = {
    name: 'AIC',
    code: '2.16.840.1.113883.2.9.6.1.5', // non c'è su GITHUB! 
    displayName: 'Farmaci AIC'
};
export const collectionTerapieFarmacologiche_GE = {
    name: 'GE',
    code: '2.16.840.1.113883.2.9.6.1.51', // non c'è su GITHUB!
    displayName: 'Farmaci GE'
};

export const collectionFarmaciAIFA = "aifa_farmaci_ATC_AIC";

export const collectionRouteAdministration = "2.16.840.1.113883.5.112";
export const collectionApproachSite = "2.16.840.1.113883.5.1052";
export const collectionFormaFarmaceutica = "2.16.840.1.113883.6.96";

export const posologiaData = [
    {
        codice: 'PIVL_TS',
        descrizione: 'b.i.d. (due volte al giorno)',
        xmlSnippet: `<effectiveTime xsi:type='PIVL_TS' institutionSpecified='true' operator='A'><period value='12' unit='h' /></effectiveTime>`
    },
    {
        codice: 'PIVL_TS',
        descrizione: 'q12h (ogni 12 ore)',
        xmlSnippet: `<effectiveTime xsi:type='PIVL_TS' institutionSpecified='false' operator='A'><period value='12' unit='h' /></effectiveTime>`
    },
    {
        codice: 'TS',
        descrizione: 'Once (una volta)',
        xmlSnippet: `<effectiveTime xsi:type='TS' value='200509010118'/>`
    },
    {
        codice: 'PIVL_TS',
        descrizione: 't.i.d. (tre volte al giorno)',
        xmlSnippet: `<effectiveTime xsi:type='PIVL_TS' institutionSpecified='true' operator='A'><period value='8' unit='h' /></effectiveTime>`
    },
    {
        codice: 'PIVL_TS',
        descrizione: 'q8h (ogni 8 ore)',
        xmlSnippet: `<effectiveTime xsi:type='PIVL_TS' institutionSpecified='false' operator='A'><period value='8' unit='h'/></effectiveTime>`
    },
    {
        codice: 'EIVL',
        descrizione: 'qam (la mattina)',
        xmlSnippet: `<effectiveTime xsi:type='EIVL' operator='A'><event code='ACM'/></effectiveTime>`
    },
    {
        codice: 'PIVL_TS',
        descrizione: 'Ogni giorno alle 8 per 10 min',
        xmlSnippet: `<effectiveTime xsi:type='PIVL_TS' operator='A'><phase><low value="198701010800" inclusive="true"/><width value="10" unit="min"/></phase><period value='1' unit='d'/></effectiveTime>`
    },
    {
        codice: 'PIVL_TS',
        descrizione: 'q4-6h (ogni 4-6 ore)',
        xmlSnippet: `<effectiveTime xsi:type="PIVL_TS" institutionSpecified="false" operator="A"><period xsi:type="PPD_PQ" value="5" unit="h"><standardDeviation value="1" unit="h"/></period></effectiveTime>`
    }
];